<template>

    <!-- In einer Sitzung stehen die Aufgaben fest: kein Filtern, kein Neu-Ziehen. -->
    <div class="category-filters" v-if="filterbar">
        <div class="kategorien" role="group" aria-labelledby="thema-titel">
            <span id="thema-titel" class="filter-titel">Thema</span>
            <button :aria-pressed="selectedCategory === null" @click="selectCategory(null)">Alle</button>
            <button v-for="c in categories" :key="c" :aria-pressed="selectedCategory === c" @click="selectCategory(c)">{{ c }}</button>
        </div>
        <div class="zufall">
            <label class="filter-titel" for="anzahl">Anzahl</label>
            <input id="anzahl" type="number" v-model.number="randomCount" min="1" />
            <button @click="pickRandomTasks">Zufällig ziehen</button>
        </div>
    </div>
    <ol class="task-list" aria-live="polite">
        <Task v-for="t in displayedTasks" :key="t.label" :task="t" :done="t.done" />
    </ol>
</template>

<script>
import Task from './Task.vue';
import {ref, computed} from 'vue'

export default {

    props: {
            tasks: Array,
            filterbar: {type: Boolean, default: true}
            },
    components: {Task},
    setup(props) {
        const selectedCategory = ref(null)
        const randomCount = ref(3)
        const randomTasks = ref(null)

        const categories = computed(() => {
            const all = props.tasks.flatMap(t => t.categories)
            return [...new Set(all)]
        })

        const filteredTasks = computed(() => {
            return selectedCategory.value === null
            ? props.tasks
            : props.tasks.filter(t => t.categories.includes(selectedCategory.value))
        })

        const pickRandomTasks = () => {
            const shuffled = [...filteredTasks.value].sort(() => Math.random() - 0.5)
            const picked = shuffled.slice(0, randomCount.value)
            randomTasks.value = filteredTasks.value.filter(t => picked.includes(t))
        }

        const displayedTasks = computed (() => randomTasks.value ?? filteredTasks.value)

        const selectCategory = (c) => {
            selectedCategory.value = c
            randomTasks.value = null
        }

        return {selectedCategory, categories, filteredTasks, pickRandomTasks, displayedTasks, randomCount, randomTasks, selectCategory}
    }
}

</script>

<style scoped>
/* Filter ueber der Aufgabenliste: die gewaehlte Kategorie zeigt sich
   (aria-pressed), damit klar ist, woraus gezogen wird. */
.category-filters {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    margin-bottom: 1.25rem;
    padding: 0.85rem;
    background: var(--zs-flaeche);
    border-radius: var(--zs-ecke);
    text-align: left;
}

.kategorien,
.zufall {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.4rem;
}

.filter-titel {
    font-size: 0.85rem;
    color: var(--zs-grau);
}

/* «Thema» auf eigener Zeile: umbrechende Themen stehen dann buendig. */
.kategorien .filter-titel {
    flex-basis: 100%;
}

.zufall .filter-titel {
    margin-right: 0.2rem;
}

.category-filters button {
    min-height: 2.25rem;
    padding: 0.3rem 0.8rem;
    font: inherit;
    font-size: 0.9rem;
    color: var(--zs-tinte);
    background: #ffffff;
    border: 1px solid var(--zs-rahmen);
    border-radius: var(--zs-ecke);
    cursor: pointer;
}

.category-filters button:hover {
    border-color: var(--zs-grau);
}

.category-filters button[aria-pressed="true"] {
    color: #ffffff;
    background: var(--zs-tinte);
    border-color: var(--zs-tinte);
}

.zufall input {
    width: 3.5rem;
    min-height: 2.25rem;
    padding: 0.3rem 0.5rem;
    font: inherit;
    font-size: 0.9rem;
    background: #ffffff;
    border: 1px solid var(--zs-rahmen);
    border-radius: var(--zs-ecke);
    box-sizing: border-box;
}

/* «Zufällig ziehen» ist eine Handlung, kein Filter: eckig wie die
   anderen Knoepfe der Spalte, nicht rund wie die Themen. */
.zufall button {
    border-radius: var(--zs-ecke);
}

.category-filters button:focus-visible,
.zufall input:focus-visible {
    outline: 3px solid var(--zs-orange);
    outline-offset: 2px;
}

.task-list {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    width: 100%;
    margin: 0;
    padding: 0;
    list-style: none;
}
</style>